import React from 'react';
import '../styles/app.scss';
import Layout from '../components/layout';
import SolicitorPanelCheckerForm from '../components/solicitor-panel-checker-form/solicitor-panel-checker-form.component';

const SolicitorPanelChecker = () => {
  return (
    <Layout 
      title="Solicitor Panel Checker"
      metaDescription="Check if your solicitor is on our approved panel."
    >
      <section className="page-section row">
        <div className="col">
          <h1 className="page-title">Solicitor Panel Checker</h1>
          <p className="page-description">Please provide your FCA reference and email address for verification, along with the contact information for the Solicitor / Conveyancer firm that you are wanting to check.</p>
          <SolicitorPanelCheckerForm />
        </div>
      </section>
    </Layout>
  );
};

export default SolicitorPanelChecker;
